import { useState, createContext, useEffect, useCallback } from "react";
import { useBreakpoints } from "../hooks/useBreakpoints";
import { CurrentMobileView } from "../models/CurrentMobileView";
import { useLogger } from "../hooks/useLogger";


export const ResponsiveContext = createContext();

export const ResponsiveContextProvider = ({ children }) => {
  const logger = useLogger();
  const getResponsive = useBreakpoints();
  const [isMobileView, setIsMobileView] = useState(getResponsive.isMobile);
  const [isNotMobileView, setIsNotMobileView] = useState(getResponsive.isNotMobile);
  const [isTabletView, setIsTabletView] = useState(getResponsive.isTablet);
  const [isDesktopView, setIsDesktopView] = useState(getResponsive.isDesktop);
  const [currentMobileView, setCurrentMobileView] = useState(CurrentMobileView.Hierarchy);
  const [previousMobileView, setPreviousMobileView] = useState(null);
  const [currentBreakpoint, setCurrentBreakpoint] = useState(getResponsive.currentBreakpoint());

  useEffect(() => {
    setIsMobileView(getResponsive.isMobile);
    setIsTabletView(getResponsive.isTablet);
    setIsDesktopView(getResponsive.isDesktop);
    setIsNotMobileView(getResponsive.isNotMobile);
  }, [getResponsive.isMobile, getResponsive.isTablet, getResponsive.isDesktop]);


  useEffect(() => {
    setCurrentBreakpoint(getResponsive.currentBreakpoint());
  }, [getResponsive.currentBreakpoint]);

  useEffect(() => {logger.UI.log('changing breakpoint: ', currentBreakpoint)}, [currentBreakpoint]);

  /**
   * 
   * @param {*} current 
   * @param {*} previous - optional: Default is null
   * @param {*} details - optional: Pass details about calling page, conditions, etc.
   */
  const updateMobileView = (current, previous = null, details = '') => {
    logger.UI.log(`${details ? details : ''} MobileView -> ${current} (previous set to ${previous})`);
    setCurrentMobileView(current);
    setPreviousMobileView(previous);
  }

  return (
    <ResponsiveContext.Provider
      displayName='ResponsiveContext'
      value={{
        isMobileView,
        isNotMobileView,
        isTabletView,
        isDesktopView,
        currentBreakpoint,
        currentMobileView,
        setCurrentMobileView,
        previousMobileView,
        setPreviousMobileView,
        updateMobileView
      }}
    >
      {children}
    </ResponsiveContext.Provider>
  );
};